import { ChevronsUpDown, FolderOpen, LayoutGrid, Plus } from 'lucide-react';
import { useMatch } from 'react-router';
import { useCurrentUser } from '@/api/hooks/auth';
import { useProjects } from '@/api/hooks/projects';
import { Menu, type MenuEntry } from '@/components';
import { paths } from '@/routing';
import styles from './TopBar.module.css';

/** Top-bar dropdown: current project + jump to any other project. */
export function ProjectSwitcher() {
  const match = useMatch('/projects/:pid/*');
  const currentId = match?.params.pid ? Number(match.params.pid) : null;
  const projects = useProjects();
  const me = useCurrentUser();
  const current = projects.data?.find((p) => p.id === currentId);

  const items: MenuEntry[] = [
    { heading: 'Projects' },
    ...(projects.data ?? []).map((p) => ({
      label: p.name,
      icon: <FolderOpen />,
      to: paths.project(p.id),
      checked: p.id === currentId,
    })),
    ...(projects.data?.length === 0 ? [{ label: 'No projects yet', disabled: true }] : []),
    'separator',
    { label: 'All projects', icon: <LayoutGrid />, to: paths.home() },
    ...(me.can_create_projects ? [{ label: 'New project', icon: <Plus />, to: paths.newProject() }] : []),
  ];

  return (
    <Menu
      label="Switch project"
      placement="bottom-start"
      items={items}
      trigger={(props) => (
        <button type="button" className={styles.switcher} {...props}>
          <span className="truncate">
            {current?.name ?? (currentId ? `Project ${currentId}` : 'Projects')}
          </span>
          <ChevronsUpDown aria-hidden />
        </button>
      )}
    />
  );
}
